const defaultColors = [
    '#d73d32',
    '#7e3794',
    '#4285f4',
    '#67ae3f',
    '#d61a7f',
    '#ff4080',
];
export function defaultInitials(name, { maxInitials }) {
    return name
        .split(/\s/)
        .map((part) => part.substring(0, 1).toUpperCase())
        .filter((v) => !!v)
        .slice(0, maxInitials)
        .join('')
        .toUpperCase();
}
export function _stringAsciiPRNG(value, m) {
    const charCodes = [...value].map((letter) => letter.charCodeAt(0));
    const len = charCodes.length;
    const a = (len % (m - 1)) + 1;
    const c = charCodes.reduce((current, next) => current + next) % m;
    let random = charCodes[0] % m;
    for (let i = 0; i < len; i++)
        random = (a * random + c) % m;
    return random;
}
export function getRandomColor(value, colors = defaultColors) {
    if (!value)
        return 'transparent';
    const colorIndex = _stringAsciiPRNG(value, colors.length);
    return colors[colorIndex];
}
//# sourceMappingURL=utils.js.map